<div class="w-100 font-16">
    <div class="row d-flex">
        <div class="col-3" *ngIf="appointment && appointment.patientName!= null">
            <strong style="font-size:17px">Patient Name :</strong>&nbsp;
            <span [textContent]="appointment.patientName"></span>
        </div>
        <div class="col-2" *ngIf="appointment && appointment.umrNo!= null">
            &nbsp;
            <strong style="font-size:17px">UMR No  : </strong>&nbsp;
            <span [textContent]="appointment.umrNo"></span>
        </div>
        <div class="col-2" *ngIf="appointment && appointment.roomName!= null">
            <strong style="font-size:17px">Room No :</strong>&nbsp;
            <span [textContent]="appointment.roomName"></span>
        </div>
        <div class="col-2" *ngIf="appointment && appointment.bedId!= null">
            <strong style="font-size:17px">Bed No :</strong>&nbsp;
            <span [textContent]="appointment.bedId"></span>
        </div>
        <div class="col-2" *ngIf="appointment && appointment.patientId != null">
            <strong style="font-size:17px"> Ip No  :</strong>&nbsp;
            <span [textContent]="appointment.patientId"></span>
        </div>
        <div>
            <a href="javascript:;" class="btn btn-secondary btn-sm ml-1" (click)="onback()">
                <span><i class="fe-arrow-left mr-1"></i> Back</span>
            </a>
        </div>
    </div>
    <div class="row d-flex">
        <div class="col-3" *ngIf="appointment && appointment.appointmentDate!= null">
            <strong style="font-size:17px">Admission Date :</strong>&nbsp;
            <span [textContent]="appointment.appointmentDate |date:'dd/MM/yyyy'"></span>
        </div>
        <div class="col-3" *ngIf="appointment && appointment.admTime!= null">
            <strong style="font-size:17px">Admission Time :</strong>&nbsp;
            <span [textContent]="appointment.admTime"></span>
        </div>
        <div class="col-3" *ngIf="appointment && appointment.patientAge!= null">
            &nbsp;
            <strong style="font-size:17px">Age : </strong>&nbsp;
            <span [textContent]="appointment.patientAge"></span>
        </div>
        <div class="col-3" *ngIf="appointment && appointment.patientGender!= null">
            <strong style="font-size:17px">Sex :</strong>&nbsp;
            <span [textContent]="appointment.patientGender"></span>
        </div>
      

    </div>
</div>

